export function Backdrop() {
  return (
    <div className="backdrop" aria-hidden="true">
      <div className="backdrop__aurora" />
      <div className="backdrop__grid" />
      <div className="backdrop__rings">
        <span className="ring--a" />
        <span className="ring--b" />
        <span className="ring--c" />
        <span className="ring--d" />
      </div>
      <div className="backdrop__orb orb--1" />
      <div className="backdrop__orb orb--2" />
      <div className="backdrop__orb orb--3" />
    </div>
  );
}
